import React from 'react';
import classNames from 'classnames';

import { ClassNamesProps } from '~/models/ClassNamesProps';

export interface SummaryItemProps extends ClassNamesProps {
    label: string;
    classnames?: string;
}

/** Label and text grouping. */
export const SummaryItem: React.FC<SummaryItemProps> = ({ label, children, classnames }) => {
    return (
        <div className={classNames('py-3 px-4 sm:px-6', classnames)}>
            <h2 className={'text-11 text-neutrals-500 mb-2'}>{label}:</h2>
            <p className={'text-14 text-platinum-800'}>{children}</p>
        </div>
    );
};
